// eslint-disable-next-line no-unused-vars
import { ILoginForm } from '../../../../../TypeScript/Interfaces/ILoginForm';

export default {
  Email: '',
  Password: '',
  KeepConnected: false,
  ShowPassword: false,
} as ILoginForm;
